import {useEffect, useRef} from 'react'

type Callback = () => void

/**
 * Executes the provided callback function once during the first rendering but only if a specific (optional) condition
 * is met.
 *
 * @param {Function} callback - The callback function to be executed.
 * @param {boolean} [condition=true] - The condition that determines whether the callback should be executed. Defaults to true.
 *
 * @returns {void}
 */
export const useRenderOnce = (callback : Callback, condition = true) => {
    const isCalledRef = useRef(false);

    useEffect(() => {
        if (condition && !isCalledRef.current) {
            isCalledRef.current = true;
            callback();
        }
    }, [callback, condition]);
}